var _g, _g2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgLeaf = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.04249 0 0 .04249 1.0716 1.2242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m499.36 5.516c-13.49-3.948-343.48-36.802-459.37 119.77-51.326 69.36-52.097 164.44-2.572 282.58-12.563 26.076-23.561 53.544-32.524 82.527-2.725 8.807 2.204 18.145 11.001 20.861 1.64 0.51 3.301 0.749 4.941 0.749 7.112 0 13.715-4.594 15.919-11.749 88.328-285.57 375.38-423.72 463.4-458.62 8.567-3.399 20.015-30.023-0.799-36.115z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(.04249 0 0 .04249 1.0716 1.2242)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m90.4 443.6c47.777 20.043 95.547 30.316 139.97 30.316 39.929 0 77.166-8.21 109.25-24.857 64.579-33.501 104.04-97.581 114.12-185.33 10.267-89.433 23.049-145.45 33.712-179.72-94.914 43.782-298.43 157.27-397.06 359.6z"
  }))));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLeaf, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/leaf.2e7a38ba.svg";
export { ForwardRef as ReactComponent };